import {ContactInfo} from 'components/common/ContactsInfo'
import {Frame} from 'components/system/Frame'
import {ReactComponent as EditIcon} from 'icons/edit.svg'
import {useTravelerPath} from 'providers/EnvironmentProvider'
import {useOrderDetails} from 'providers/OrderDetailsProvider'
import {useCallback} from 'react'

export const Contact = () => {
  const orderIntent = useOrderDetails()
  const travelerPath = useTravelerPath()

  const goToContacts = useCallback(() => {
    window.location.href = travelerPath
  }, [travelerPath])

  return (
    <Frame className="flex justify-between items-start p-4">
      <ContactInfo contact={orderIntent.contact} />
      <div
        className="flex items-center gap-2 text-french-blue-030 cursor-pointer hover:opacity-80"
        onClick={goToContacts}
      >
        <EditIcon />
        <div>Edit contacts</div>
      </div>
    </Frame>
  )
}
